import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function PCPlatformIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M9.57778 19C9.14822 19 8.8 18.6518 8.8 18.2222C8.8 17.7927 9.14822 17.4444 9.57778 17.4444H10.4V15.8889H5.6C5.16 15.8889 4.78347 15.7367 4.4704 15.4323C4.15733 15.128 4.00053 14.7616 4 14.3333V6.55556C4 6.12778 4.1568 5.7617 4.4704 5.45733C4.784 5.15296 5.16053 5.00052 5.6 5H18.4C18.84 5 19.2168 5.15244 19.5304 5.45733C19.844 5.76222 20.0005 6.1283 20 6.55556V14.3333C20 14.7611 19.8435 15.1274 19.5304 15.4323C19.2173 15.7372 18.8405 15.8894 18.4 15.8889H13.6V17.4444H14.4222C14.8518 17.4444 15.2 17.7927 15.2 18.2222C15.2 18.6518 14.8518 19 14.4222 19H9.57778ZM5.6 14.3333H18.4V6.55556H5.6V14.3333Z"
        fill="currentColor"
      />
    </svg>
  );
}
